const default_assistant_reply =
  "I can help with system navigation, dashboards, profile screens, login flow, and how the current reporting setup works.";

const assistant_reply_rules = [
  {
    keywords: ["dashboard", "report", "superset"],
    text: "The system is focused on embedded dashboards. Use the sidebar to switch between reporting areas, and the main view will load the linked dashboard automatically."
  },
  {
    keywords: ["profile", "account", "user"],
    text: "Your profile area is for viewing and updating account details like name and contact information. You can open it from the header profile icon."
  },
  {
    keywords: ["sidebar", "menu", "navigation"],
    text: "The sidebar is the main navigation for the system. Selecting a menu item changes the active reporting section and loads its mapped dashboard."
  },
  {
    keywords: ["password", "login", "otp"],
    text: "Authentication in the system includes login, one-time pin verification, and password reset screens. If something fails there, we can trace it from the auth flow."
  },
  {
    keywords: ["social impact", "intelligence"],
    text: "Social Impact Intelligence is the default reporting entry point in the system, and the other sidebar items load their own mapped dashboard ids."
  }
];

function matches_any_keyword(query, keywords = []) {
  return keywords.some(keyword => query.includes(keyword));
}

export function get_assistant_reply(query) {
  const matched_rule = assistant_reply_rules.find(rule =>
    matches_any_keyword(query, rule.keywords)
  );

  return matched_rule?.text || default_assistant_reply;
}
